/* A hash router, and deliberately the smallest one that works.
 *
 * The demo routes on the hash and the acceptance suite is written against those URLs,
 * so the vocabulary is kept rather than a second one invented: #/members/:id,
 * #/leads/:id, #/classes. A real router is a decision for when there are twenty
 * screens, not five.
 */
import { useEffect, useState } from 'react';

export interface Route { name: string; id?: string }

export function parse(hash: string): Route {
  const h = hash.replace(/^#/, '').replace(/^\//, '');
  const [head, second] = h.split('?')[0]!.split('/');
  if (!head) return { name: '__home__' };
  // A record is the list's name plus an id: #/members/abc is the member, not the list.
  if (second) return { name: head === 'members' ? 'member-detail' : head === 'leads' ? 'lead-detail' : head, id: decodeURIComponent(second) };
  return { name: head };
}

export function go(to: string): void { window.location.hash = to.replace(/^#/, ''); }

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parse(window.location.hash));
  useEffect(() => {
    const on = () => { setRoute(parse(window.location.hash)); window.scrollTo(0, 0); };
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}
